import React, { useRef } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import { useNavigate } from "react-router-dom";

DataTable.use(DT);

const SupportingContentTable = ({ supportingContent = [] }) => {
  const navigate = useNavigate();
  const tableRef = useRef(null);

  const tableData = supportingContent.map((item) => {
    return [
      item.public_id,
      item.name ?? "N/A",
      item.description ?? "N/A",
      item.content_type,
    ];
  });

  return (
    <div>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        Supporting Content
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          rowCallback: (row, rowData) => {
            row.onclick = () => {
              console.log(
                `Row clicked: /client/supporting-content-items/${rowData[0]}`
              );
              navigate(`/client/supporting-content-items/${rowData[0]}`);
            };
          },
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
            <th>Content Type</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default SupportingContentTable;
